import React from "react";
import SetPassword from "./setpassword";

class SetPasswordParent extends React.Component {
  render() {
    return <SetPassword />;
  }
}

export default SetPasswordParent;